import React from 'react';

export const About = () => {
  return (
    <div className="about">
      <h1 className="section-h1">About Me</h1>
      <p>
        Hi, my name is Kirill and I am a web developer!
        <br />
        I really enjoy programming, I'm sure it's my passion. 
        I spend most of my free time improving my coding skills in hopes of 
        one day becoming a great software engineer. 
        <br />
        <span className="important-text">If you are interested, please contact me!</span>
      </p>
    </div>
  );
};
